import { AfterViewInit, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonService } from './_services/common.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  encapsulation: ViewEncapsulation.None,

  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'solidrange';
  currentLanguage = 'en';

  constructor(public commonService: CommonService) {


    if (localStorage.getItem('lang') === 'en') {
      const temp = document.createElement('script');
      const temp2 = document.createElement('script');
      const title = document.createElement('title')
      title.innerHTML = 'GRC and Human Risk Management Solutions'
      temp.innerHTML = 'window.pipedriveLeadboosterConfig = {base: "leadbooster-chat.pipedrive.com",companyId: 10284680,playbookUuid: "6c877d2a-895b-401a-8283-c980cea21ed6",version: 2};(function () {var w = window;if (w.LeadBooster) {console.warn("LeadBooster already exists");} else {w.LeadBooster = {q: [],on: function (n, h) {this.q.push({ t: "o", n: n, h: h });},trigger: function (n) {this.q.push({ t: "t", n: n });},};}})();';
      temp2.src = 'https://leadbooster-chat.pipedrive.com/assets/loader.js async'
      temp2.innerHTML;
      document.getElementsByTagName('head')[0].appendChild(temp)
      document.getElementsByTagName('head')[0].appendChild(temp2)
      document.getElementsByTagName('head')[0].appendChild(title)
    }

    if (localStorage.getItem('lang') === 'ar') {
      const title = document.createElement('title')
      const temp = document.createElement('script');
      title.innerHTML = 'إدارة الحوكمة والمخاطر والالتزام والتوعية السيبرانية'
      temp.innerHTML = 'window.pipedriveLeadboosterConfig = { base: "leadbooster-chat.pipedrive.com", companyId: 10284680, playbookUuid: "86315fc3-4326-4d49-89cd-b4fc3b44289e", version: 2 }; (function () { var w = window; if (w.LeadBooster) { console.warn("LeadBooster already exists"); } else { w.LeadBooster = { q: [], on: function (n, h) { this.q.push({ t: "o", n: n, h: h }); }, trigger: function (n) { this.q.push({ t: "t", n: n }); }, }; } })();'
      document.getElementsByTagName('head')[0].appendChild(temp)
      document.getElementsByTagName('head')[0].appendChild(title)
    }
  }

  toggleSideMenu() {
    this.commonService.toggleSideMenu()
  }
  ngOnInit() {
    this.commonService.resize()
    this.commonService.getCurrentLanguage()
  }

  ngAfterViewInit() {
  const lang = this.commonService.getCurrentLanguage(); // 'en' or 'ar'

  // Set HTML language attribute
  document.documentElement.lang = lang;

  // Expose to index.html chat script
  (window as any).APP_LANG = lang;

  // Initialize / update chat
  if ((window as any).switchChatLanguage) {
    (window as any).switchChatLanguage(lang);
  }
}

}
